/** @format */

export interface CustomBadge {
  background: string;
  text: string;
  textColor: string;
}
